










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';

import { Row } from './TableModel';

@Component({
  components: {
    ContextMenu,
    CustomSelect
  }
})
export default class RowsTable extends Vue {
  @Prop() rows!: Row[];
  @Prop() keyOrder!: string[];
  @Prop({ required: false }) classRow!: string;
  @Prop({ required: true }) hover!: boolean;
  @Prop({ default: false }) adminRow!: boolean;
  @Prop({ default: false }) isRounded!: any;
  @Prop({ default: () => [] }) unclickableKeys!: string[];
  @Prop({ default: () => false }) dynamicClassName!: (row: any) => string;

  @Watch('rows')
  onChange(value: string, oldValue: string) {
    this.order();
  }

  created() {
    this.order();
  }

  rowOrdenade: Row[] = [];

  order() {
    if (!this.rows) return (this.rows = []);
    // CLEAN VARIABLE GLOBAL
    this.rowOrdenade = [];

    this.rows.forEach((row: Row) => {
      // ARRAY IN ORDER CORRECT
      const rowOrdenade: any = [];
      //
      this.keyOrder.forEach((keyToOrder: string) => {
        if (keyToOrder === 'date' || keyToOrder === 'createdAt') {
          let date = row[keyToOrder];
          rowOrdenade.push(date);
          return;
        }
        if (keyToOrder === 'picture') {
          rowOrdenade.push(`isAnImage ${row[keyToOrder].toString()}`);
          return;
        }
        if (keyToOrder.includes('slot')) {
          rowOrdenade.push(keyToOrder);
          return;
        }
        rowOrdenade.push(row[keyToOrder].toString());
      });
      //
      this.rowOrdenade.push(rowOrdenade);
    }); // ONE ROW
  }

  clicked(index: number, idx: number, event: any, td: string) {
    if (this.unclickableKeys.includes(td)) {
      if (event.target.id != idx) return false;
    }

    this.$emit('clicked', {
      id: this.rows[index] ? this.rows[index].id : '',
      type: this.rows[index].type,
      row: this.rows[index],
      event: event,
      tdId: idx
    });
  }

  isImage(url: string) {
    const urlRegex = /(isAnImage?:\/\/[^\s]+)/g;
    return url.includes('isAnImage');
  }

  getTypeImage(url: string) {
    if (url.includes('https')) {
      return 'image';
    }
    return 'initials';
  }

  getImage(url: string) {
    return url.replace('isAnImage ', '');
  }
}
